export function focusById(id: string) {
  (document.getElementById(id) as HTMLInputElement | null)?.focus();
}
